export default __webpack_public_path__ + "media/images/backup_logo/logo-pride-49a229b0421d8d053197fb9b349417a1.svg";